import React, { forwardRef, useContext, useEffect, useLayoutEffect, useRef, useState } from "react"
import Input from "../../atoms/Input"
import RcmpSelectActivityRow from "../../atoms/SelectActivityRow"
import intl from "react-intl-universal"
import styles from './index.module.scss'
import useClickOutside from "../../../hooks/useClickOutside"
import HoverEditTextFieldIcon from "../../../assets/icons/HoverEditTextFieldIcon"
import useDataApi from "../../../hooks/useDataApi"
import { fnUpdateFieldRow } from "../../../services/activityFields"
import { ToastContainer, toast } from "@stardust-ds/react"
import RcmpDatePicker from "../../atoms/DatePicker"
import { fnFormatDate, fnIsValidDate, fnFormatDateFromDate, fnFormatDateToUTC, fnFormatDateFromUTC } from "../../../utils/date"
import AuthContext from "../../../contexts/Auth"
import BoardContext from "../../../contexts/Board"
import { fnIsResponsible } from "../../../utils/permissions"
import { cDeadLineSlug, cStatusSlug, dConclusionDateSlug, dCreationDateSlug } from "../../../constans/activity-slugs"
import { BlocksContext } from "../../../contexts/Blocks"
import { useNavigate, useParams } from "react-router"
import moment, { min } from "moment"
import { fnUpdateActivity } from "../../../services/acitivities"
import { NumericFormat } from "react-number-format"
import RcmpCardUsers from "../../atoms/CardUsers"
import RcmpModalInfo from '../../organisms/ModalInfo'
import PaineisContext from "../../../contexts/Paineis"

export const RcmpTableField = forwardRef((props, ref) => {
  const {
    fieldProps,
    onMouseEnter,
    onMouseOut,
    bDisabledEdit,
    data,
    className,
    fnSetBHasClickedOutSide,
    id,
    aAllFields,
    columnId,
    oBlock,
    fnCompareDate,
    cActivityStatus,
    bCanChange,
    ...rest
  } = props

  const cClass = `${styles.inputStyle} ${className ? className : ""}`
  const [cOnChange, fnSetCOnChange] = useState(data)
  const cOnChangeRef = useRef(cOnChange)
  const [bIsEditing, fnSetBIsEditing] = useState(false)
  const [oUpdateFieldRowRes, oUpdateFieldRowReq, fnUpdateFieldRowReset] = useDataApi(fnUpdateFieldRow)
  const [oUpadteFieldStatusRowRes, oUpadteFieldStatusRowReq] = useDataApi(fnUpdateActivity)
  const cFieldType = fieldProps?.column?.columnDef?.footer.split("-")[0]
  const [nSelectedEditFieldId, fnSetNSelectedEditFieldId] = useState(-1)
  const inputRef = useRef(null)
  const selectRef = useRef(null)
  const cFieldId = fieldProps?.column?.id
  const oFieldData = aAllFields?.find((field) => field?.opfd_nid == cFieldId)
  const cFieldSlug = oFieldData?.opfd_cslug
  const fieldId = Number(fieldProps.column.columnDef.accessorKey.split("-")[1])
  const cNumberFieldPrefixSufix = fieldProps?.row?.original?.[`fieldNumber-` + fieldId]
  const bHasPrefixSufix = fieldProps?.row?.original?.[`fieldHasPrefix-` + fieldId]
  const nFieldNumberPrecision = fieldProps?.row?.original?.[`fieldNumberPrecision-` + fieldId]
  const cOriginalValue = fieldProps?.row?.original?.[`fieldValueToRender-${fieldId}`]
  const cOriginalValueSelect = fieldProps?.row?.original?.[`fieldValueToRenderSelect-${fieldId}`]
  const fieldLimits = fieldProps?.row?.original?.[`fieldLimits-` + fieldId]
  const cColorSelection = fieldProps?.row?.original?.[`fieldColor-${fieldId}`]
  const nActivityId = fieldProps?.row?.original?.[`activityID`]
  const dConclusionDate = fieldProps?.row?.original?.[`conclusionDate-${nActivityId}`]
  const [cValueText, fnSetCValueText] = useState(cOriginalValue)
  const dateRef = useRef(null)
  const numberFieldRef = useRef(null)
  const { oCurrentPanel } = useContext(PaineisContext)
  const { oCurrentBoard } = useContext(BoardContext)
  const { oUser } = useContext(AuthContext)
  const cUserTimeZone = oUser?.data?.user_ctimezone
  const { fnFetchActivitiesByBlock, fnSetOparams } = useContext(BlocksContext)
  const nUserId = oUser?.data?.user_nid
  const bCanEditDate = fnIsResponsible(nUserId, oCurrentBoard?.responsibles)
  const bUserIsAdmin = oUser?.data?.bIsAdmin
  const bCanEditConclusionDate = oCurrentPanel?.bIsResponsible || oCurrentBoard?.bIsResponsible || bUserIsAdmin

  function openToastSuccess() {
    toast({
      type: "success",
      title: intl.get("table_fields.toast.success"),
      description: intl.get("table_fields.toast.success_message"),
    })
  }


  useLayoutEffect(() => {
    if (bIsEditing) return
    fnSetCOnChange(data)
  })
  function fnCompareDateConclusion(dDeadLine) {
    const dDate = fnFormatDate(dDeadLine, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]", false, cUserTimeZone, "DD/MM/YYYY HH:mm")
    const dConclusionDateFormated = fnFormatDate(dConclusionDate, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]", false, cUserTimeZone, "YYYY-MM-DD HH:mm")
    const dCurrentDate = moment().format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
    if (cActivityStatus !== "Done" && !dConclusionDate) {
      return moment(dDate).isBefore(dCurrentDate)
    }
    return moment(dConclusionDateFormated).isBefore(dDate)
  }
  function fnOpenToastInvalidDate() {
    toast({
      type: "error",
      title: intl.get("table_fields.toast.fail"),
      description: intl.get("table_fields.toast.invalid_date"),
    })
  }

  function fnOpenToastFail() {
    return toast({
      fieldId,
      type: "error",
      title: intl.get("table_fields.toast.fail"),
      description: intl.get("table_fields.toast.fail_message"),
    })
  }
  function fnOpenToastFailRequiredFields() {
    return toast({
      fieldId,
      type: "error",
      title: intl.get("table_fields.toast.fail"),
      description: intl.get("table_fields.toast.fail_message_required_fields"),
    })
  }

  useEffect(() => {
    numberFieldRef.current = ""
  }, [nSelectedEditFieldId])

  useEffect(() => {
    if (!oUpdateFieldRowRes.done) return
    if (oUpdateFieldRowRes.data) {
      fnSetCOnChange(cOriginalValue)
      openToastSuccess()

      fnFetchActivitiesByBlock(oBlock.opbl_nid)
      fnSetNSelectedEditFieldId(-1)
      return
    }


    if (oUpdateFieldRowRes.error) {
      fnSetCOnChange(data)
      fnFetchActivitiesByBlock(oBlock.opbl_nid)
      fnOpenToastFail()
      fnSetNSelectedEditFieldId(-1)
      return
    }
    fnUpdateFieldRowReset()
  }, [oUpdateFieldRowRes])

  useEffect(() => {
    if (!oUpadteFieldStatusRowRes.done) return

    if (oUpadteFieldStatusRowRes.data) {
      openToastSuccess()
      fnFetchActivitiesByBlock(oBlock.opbl_nid)
      fnSetNSelectedEditFieldId(-1)
    }


    if (oUpadteFieldStatusRowRes.error) {
      if (oUpadteFieldStatusRowRes?.error?.response?.status === 422) {
        fnOpenToastFailRequiredFields()
        fnFetchActivitiesByBlock(oBlock.opbl_nid)
        return
      }
      fnSetCOnChange(data)
      fnOpenToastFail()
      fnSetNSelectedEditFieldId(-1)
    }
    fnUpdateFieldRowReset()
  }, [oUpadteFieldStatusRowRes])

  useEffect(() => {

    const handleClickOutside = (event) => {
      if (event.key === "Enter" && "DATE" === cFieldType) {
        dateRef.current !== null && fnClickedOutSide(event)
        return
      }
      if (["Enter", "Tab"].includes(event.key) && ["TEXT", "DESCRIPTION", "NUMBER", "RANGE"].includes(cFieldType)) {
        inputRef?.current && fnClickedOutSide(event)
        return
      }
      if (event.key == ["Escape"] && ["TEXT", "DESCRIPTION", "NUMBER", "DATE", "RANGE"].includes(cFieldType)) {
        event.stopPropagation()
        event.preventDefault()
        fnSetNSelectedEditFieldId(-1)
        if (cFieldType === "DATE") {
          cOnChangeRef.current = fnFormatDateToUTC(cOnChangeRef.current, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS") // used to reder right value on grid after cancel
        }
        return
      }
      if (
        (dateRef.current && !dateRef.current.contains(event.target))
      ) {

        fnClickedOutSide(event)
        event.stopPropagation()
        event.preventDefault()
        fnSetNSelectedEditFieldId(-1)
        return
      }
    }

    window.addEventListener("keydown", handleClickOutside)
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
      window.removeEventListener("keydown", handleClickOutside)
    }
  }, [])

  const [isExecuted, setIsExecuted] = useState(false)
  const [cMessage, fnSetCMessage] = useState('')
  const [cTitle, fnSetCTitle] = useState('Atenção')
  const [bCanSave, fnSetBCanSave] = useState(false)
  const observerRef = useRef(null)

  useEffect(() => {
    observerRef.current = new MutationObserver((mutations) => {
      if (mutations[0].type === "childList" && mutations[0].removedNodes.length > 0) {
        if (!cOnChange || dateRef.current === null) return
        if (!isExecuted) {
          setIsExecuted(true)
          fnClickedOutSide()
          //fnSetNSelectedEditFieldId(-1)
        }
      } else {
        setIsExecuted(false)
      }
    })

    observerRef.current.observe(document.body, { childList: true })

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect()
      }
    }
  }, [])

  async function fnEditFieldRowSubmit(nActivityId, oData) {
    try {

      await oUpdateFieldRowReq(nActivityId, oData)
      fnSetOparams({ bAppendToList: false, bPaginatedList: false, bUpdateList: false })
      await fnFetchActivitiesByBlock(oBlock.opbl_nid)
      if (bIsEditing) return
    } catch (e) {
      return
    }



  }
  async function fnHandleValueSelectField(oData) {

    if (cFieldType === "SELECTION" && cFieldSlug !== cStatusSlug) {
      fnEditFieldRowSubmit(fieldProps.row.original.activityID, { field_id: fieldId, opfv_cvalue: oData.opfs_coption_name, opfv_opfs_nid: oData.opfv_opfs_nid })
      return
    }

    if (cFieldType === "SELECTION" && cFieldSlug === cStatusSlug) {
      await oUpadteFieldStatusRowReq({ opat_nid: fieldProps?.row?.original?.activityID, status: oData.opfs_coption_name, conclusionDate: null, arr_nfields_to_delete: [], inline: true })
      return
    }

    fnEditFieldRowSubmit(fieldProps.row.original.activityID, { field_id: fieldId, opfv_cvalue: oData.opfs_coption_name })
    return

  }

  function RcmpNumberField() {
    const [nNumberFieldValue, fnSetNNumberFieldValue] = useState(cOnChangeRef.current)
    // const cCurrentValueWithoutString = cOnChangeRef?.current?.replace(/[^0-9.,]/g, '');
    fnSetCOnChange(cOnChangeRef?.current)
    function fnHandleOnChange(e) {
      e.stopPropagation()
      e.preventDefault()
      const value = e?.target?.value
      const valueWithoutPrefix = value.replace(cNumberFieldPrefixSufix, '');
      fnSetNNumberFieldValue(valueWithoutPrefix);
      numberFieldRef.current = valueWithoutPrefix
    }
    return (
      <div className={styles.numberField} ref={inputRef}>
        <NumericFormat
          defaultValue={nNumberFieldValue}
          decimalScale={nFieldNumberPrecision || 0}
          prefix={bHasPrefixSufix ? cNumberFieldPrefixSufix : ""}
          suffix={!bHasPrefixSufix ? cNumberFieldPrefixSufix : ""}
          allowLeadingZeros
          fixedDecimalScale
          decimalSeparator=","
          onChange={fnHandleOnChange}
          onClick={e => e.stopPropagation()}
        />
      </div>

    )
  }

  function fnHandleOnChangeDate(date) {
    // check date format
    const cDateOriginalFormat = date?.indexOf("-") > -1 ? "YYYY-MM-DD HH:mm" : "DD/MM/YYYY HH:mm"
    const dFormatedDate = fnFormatDate(date, cDateOriginalFormat, false, cUserTimeZone, cDateOriginalFormat)
    const result = fnCompareDate(fnFormatDate(date, cDateOriginalFormat, false, cUserTimeZone))

    if ((result && bCanEditDate) || !result) {
      fnSetCOnChange(dFormatedDate)
    }
    /*const dDateValue = date
    const dDateValue = date?.target?.value || date
    if (!dDateValue?.length || !dDateValue) return
    if (dDateValue.length === 10) {
        const dateString = dDateValue
        const format = "DD/MM/YYYY HH:mm"
        const isValidDate = moment(dateString, format, true)
        if (!isValidDate.isValid()) {
            fnSetCOnChange(dOldDate)
            fnSetNIdEnabled(-1)
            fnOpenToastInvalidDate()
            return
        }
    }

    const result = fnCompareDate(dDateValue)
    const dFormatedDate = fnFormatDate(dDateValue, "DD/MM/YYYY", true, cUserTimeZone)
    fnSetCOnChange(dFormatedDate)
    if (result && bCanEditDate) {
        return fnSetCOnChange(fnFormatDate(dDateValue, "DD/MM/YYYY", true, cUserTimeZone))
    }
    if (!result) {
        const dDateFormated = fnFormatDate(dDateValue, "DD/MM/YYYY", true, cUserTimeZone)
        fnSetCOnChange(dDateFormated)
        return
    }
    if (!fnIsValidDate(dDateValue)) {
        return fnSetCOnChange(fnFormatDate("00-00-0000", "DD/MM/YYYY", true, cUserTimeZone))
    }
    return*/
  }

  useEffect(() => {
    cOnChangeRef.current = cOnChange
  }, [cOnChange])

  async function fnClickedOutSide() {
    if (cFieldType === "DATE") {
      if (!cOnChangeRef.current) return openToastSuccess()
      if (cOnChangeRef.current === "Invalid date") {
        fnSetNSelectedEditFieldId(-1)
        return fnOpenToastInvalidDate()
      }

      const dFormatedDate = fnFormatDateToUTC(cOnChangeRef.current, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS")
      const dValueToCopare = fnFormatDate(cOnChange, "YYYY-MM-DD[T]HH:mm:ss.SSS", false, cUserTimeZone, "YYYY-MM-DD HH:mm")

      if (moment(dValueToCopare).isSame(dFormatedDate)) { // check if date is the same
        fnSetCOnChange(fnFormatDateToUTC(cOnChangeRef.current, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"))
        cOnChangeRef.current = fnFormatDateToUTC(cOnChangeRef.current, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS")
        fnSetNSelectedEditFieldId(-1);
        return;
      }
      await fnEditFieldRowSubmit(fieldProps.row.original.activityID, { field_id: fieldId, opfv_cvalue: dFormatedDate })

      return
    }

    if (cFieldType.toUpperCase() === "NUMBER" || cFieldType.toUpperCase() === "RANGE") {
      const nNumberValue =
        numberFieldRef.current === null || numberFieldRef.current === ""
          ? cOnChangeRef.current
          : numberFieldRef.current

      if (
        fieldLimits?.max_limit &&
        fieldLimits?.min_limit &&
        fieldLimits?.min_ideal &&
        fieldLimits?.max_ideal
      ) {

        const minLimit = Number(fieldLimits.min_limit.replace(",", '.'))
        const maxLimit = Number(fieldLimits.max_limit.replace(",", '.'))
        const minIdeal = Number(fieldLimits.min_ideal.replace(",", '.'))
        const maxIdeal = Number(fieldLimits.max_ideal.replace(",", '.'))
        const value = Number(nNumberValue.replace(",", '.'))
        if (isNaN(value)) {
          return
        }
        if (
          value < minLimit ||
          value > maxLimit
        ) {
          fnSetCMessage(
            () =>
              "O valor digitado está fora dos limites mínimo/máximo configurados. Por favor digite um valor entre " +
              fieldLimits.min_limit +
              " e " +
              fieldLimits.max_limit +
              "!",
          )
          fnSetCTitle(() => "Valor Excedido!")
          fnSetBCanSave(() => false)
          return
        }
        if (
          value >= minLimit &&
          value <= minIdeal
        ) {
          fnSetCMessage(
            () =>
              "Atenção: O número digitado está entre o Limite Mínimo e o Mínimo Ideal",
          )
          fnSetCTitle(() => "Atenção!")
          fnSetBCanSave(() => true)
          return
        }
        if (
          value > minIdeal &&
          value < maxIdeal
        ) {
          fnSetCMessage(() => "")
          fnSetBCanSave(() => true)
          await fnEditFieldRowSubmit(fieldProps.row.original.activityID, {
            field_id: fieldId,
            opfv_cvalue: numberFieldRef.current,
          })
          return
        }
        if (
          value >= maxIdeal &&
          value <= maxLimit
        ) {
          fnSetCMessage(
            () =>
              "Atenção: O número digitado está entre o Máximo Ideal e o Limite Máximo",
          )
          fnSetCTitle(() => "Atenção!")
          fnSetBCanSave(() => true)
          return
        }
      }
      await fnEditFieldRowSubmit(fieldProps.row.original.activityID, {
        field_id: fieldId,
        opfv_cvalue: nNumberValue,
      })
      return
    }
    await fnEditFieldRowSubmit(fieldProps.row.original.activityID, { field_id: fieldId, opfv_cvalue: cOnChangeRef.current })
    return
  }

  function fnEnableEditField(id, e) {
    e.stopPropagation()
    e.preventDefault()
    fnSetNSelectedEditFieldId(id)
  }

  function fnFormatDateToField(data) {
    if (!data || data === null) return
    const cDateOriginalFormat = data?.indexOf("-") > -1 ? "YYYY-MM-DD HH:mm" : "DD/MM/YYYY HH:mm"
    return fnFormatDate(data, "YYYY-MM-DD HH:mm", true, cUserTimeZone, cDateOriginalFormat)
  }

  useClickOutside(inputRef, fnClickedOutSide)

  if (dConclusionDateSlug === cFieldSlug && cActivityStatus == "Done" && id === nSelectedEditFieldId) {
    const dateString = cOnChange
    const cDefaultValue = fnFormatDate(cOnChangeRef?.current, "YYYY-MM-DD HH:mm", true, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
    return (
      <div className={styles.dateArea} ref={dateRef}>
        <RcmpDatePicker
          autoFocus
          className={className}
          defaultValue={cDefaultValue}
          onChange={fnHandleOnChangeDate}
          bTime={true}
          {...rest}
        />
      </div>
    )
  }

  if (cFieldType === "DATE" && id === nSelectedEditFieldId) {
    const dateString = cOnChange?.props?.children === "" ? null : cOnChange?.props?.children || cOnChange
    const cDefaultValue = fnFormatDateToField(dateString)
    const cDateOriginalFormat = dateString?.indexOf("-") > -1 ? "YYYY-MM-DD HH:mm" : "DD/MM/YYYY HH:mm"
    const cFormatedDate = fnFormatDate(cOnChangeRef?.current, "YYYY-MM-DD HH:mm", true, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
    return (
      <div className={styles.dateArea} ref={dateRef}>
        <RcmpDatePicker
          autoFocus
          className={className}
          defaultValue={cFormatedDate}
          onChange={fnHandleOnChangeDate}
          bTime={true}
          {...rest}
        />
      </div>
    )
  }

  const fnCheckRange = (currValue) => {
    if (!fieldLimits) return false
    if (!currValue.replace(cNumberFieldPrefixSufix, "").trim()) return false


    const value = Number(cOriginalValue.replace(cNumberFieldPrefixSufix, "").replace(",", '.').trim())//nNumberValue.replace(',', '.') 
    const minLimit = Number(fieldLimits.min_limit.replace(',', '.'))
    const maxLimit = Number(fieldLimits.max_limit.replace(',', '.'))
    const minIdeal = Number(fieldLimits.min_ideal.replace(',', '.'))
    const maxIdeal = Number(fieldLimits.max_ideal.replace(',', '.'))

    if (value < minLimit || value > maxLimit) return true
    return value >= minLimit && value <= minIdeal || value >= maxIdeal && value <= maxLimit
  }

  if (
    ["TEXT", "DESCRIPTION", "CALC"].includes(cFieldType) &&
    id === nSelectedEditFieldId
  ) {
    return (
      <Input
        ref={inputRef}
        disabled={nSelectedEditFieldId == id ? false : true}
        autoFocus={nSelectedEditFieldId == id ? true : false}
        className={cClass}
        onMouseOut={onMouseOut}
        onMouseEnter={onMouseEnter}
        defaultValue={cOriginalValue}
        value={cValueText}
        onChange={(e) => {
          fnSetCOnChange(e.target.value)
          fnSetCValueText(e.target.value)
        }}
        id={id}
        {...rest}
      />
    )
  }
  if (cFieldType === "SELECTION") {
    return (
      <RcmpSelectActivityRow
        cFieldSlug={cFieldSlug}
        selected={cOriginalValueSelect}
        aAllFields={aAllFields}
        columnId={columnId}
        oBlock={oBlock}
        ref={selectRef}
        bCanChange={bCanChange}
        onChange={fnHandleValueSelectField}
        fnSetNIdEnabled={fnSetNSelectedEditFieldId}
        nActivityId={fieldProps?.row?.original?.activityID}
        fieldColor={cColorSelection}
      />
    )
  }
  if (["NUMBER", "RANGE"].includes(cFieldType) && id === nSelectedEditFieldId) {
    return (
      <>
        <RcmpNumberField type={cFieldType.toLowerCase()} />

        <RcmpModalInfo
          bIsOpen={cMessage.length > 0}
          description={cMessage}
          title={cTitle}
          onlyCancel={!bCanSave}
          size="sm"
          fnHandleConfirm={async () => {
            await fnEditFieldRowSubmit(fieldProps.row.original.activityID, {
              field_id: fieldId,
              opfv_cvalue: numberFieldRef.current,
            })
            fnSetCMessage('')

            return
          }}
          fnHandleCancel={() => { fnSetCMessage('') }}
        />
      </>
    )
  }
    if (
        ["TEXT", "DESCRIPTION", "DATE", "NUMBER", "RANGE"].includes(cFieldType) && ![dCreationDateSlug].includes(cFieldSlug) && id !== nSelectedEditFieldId) {

            let cFormatedValue = cFieldType === "DATE" ? fnFormatDate(cOnChangeRef?.current, "DD/MM/YYYY HH:mm", true, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]") : cFieldType === "NUMBER" ? cOnChangeRef?.current : cOriginalValue

            const cFormatedDeadLine = (cFieldSlug === "prazo" && cFieldType === "DATE") && cFormatedValue
            
        if (cFieldSlug === dConclusionDateSlug && cActivityStatus !== "Done") return
        if (["NUMBER"].includes(cFieldType)) {
            const cValueWithSufixPrefix = bHasPrefixSufix ? `${cNumberFieldPrefixSufix} ${(cFormatedValue || "")}` : !bHasPrefixSufix ? `${(cFormatedValue || "")} ${cNumberFieldPrefixSufix}` : cFormatedValue
            cFormatedValue = cValueWithSufixPrefix
        }
        const bCanChangeField = ((bCanChange && cFieldSlug !== dConclusionDateSlug) || (cFieldSlug === dConclusionDateSlug && bCanEditConclusionDate))
    return (
      <div className={bCanChangeField ? styles.textWithoutSelection : styles.textWithoutSelectionCantChange}>
        {bCanChangeField && <div className={styles.toolTipContainer}>
          <HoverEditTextFieldIcon
            onClick={async (e) => {
              fnSetBIsEditing(true)
              e.stopPropagation()
              e.preventDefault()
              if (nSelectedEditFieldId !== -1) {
                fnSetCOnChange(cOriginalValue)
                await fnEditFieldRowSubmit(fieldProps.row.original.activityID, {
                  field_id: fieldId,
                  opfv_cvalue: cValueText,
                })
                fnSetNSelectedEditFieldId(-1)
                fnEnableEditField(id, e)
                return
              }
              fnEnableEditField(id, e)
            }}
          />
        </div>}
        <td>
          <p
            style={{
              color:
                cFormatedDeadLine.length > 0 && fnCompareDate(cOnChangeRef?.current)
                  ? "#FF3541"
                  : "",
              fontWeight:
                cFormatedDeadLine.length > 0 && fnCompareDate(cOnChangeRef?.current)
                  ? "600"
                  : "",
            }}
          >
            <span style={{ color: cFieldType === "RANGE" && fnCheckRange(cFormatedValue) ? "red" : "" }}>

              {cFormatedDeadLine.length > 0 ? cFormatedDeadLine : cFormatedValue}
            </span>
          </p>
        </td>
      </div>
    )
  }
  if (["TEXT", "DESCRIPTION", "CALC"].includes(cFieldType) && id === nSelectedEditFieldId) {
    return (
      <Input
        ref={inputRef}
        disabled={nSelectedEditFieldId == id ? false : true}
        autoFocus={nSelectedEditFieldId == id ? true : false}
        className={cClass}
        onMouseOut={onMouseOut}
        onMouseEnter={onMouseEnter}
        defaultValue={cOriginalValue}
        value={cValueText}
        onChange={e => { fnSetCOnChange(e.target.value); fnSetCValueText(e.target.value) }}
        id={id}
        {...rest}
      />
    )

  }
  if (cFieldType === "SELECTION") {
    return (
      <RcmpSelectActivityRow
        cFieldSlug={cFieldSlug}
        selected={cOriginalValueSelect}
        aAllFields={aAllFields}
        columnId={columnId}
        oBlock={oBlock}
        ref={selectRef}
        onChange={fnHandleValueSelectField}
        fnSetNIdEnabled={fnSetNSelectedEditFieldId}
        nActivityId={fieldProps?.row?.original?.activityID}
        fieldColor={cColorSelection}
        bCanChange={bCanChange}
      />
    )


    }
    if (cFieldType === "NUMBER" && id === nSelectedEditFieldId) {

        return (
            <RcmpNumberField />
        )
    }

    if (cFieldSlug === dCreationDateSlug) {
        const dFormattedDate = fnFormatDate(cOnChangeRef?.current, "DD/MM/YYYY HH:mm", false, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
        return (
            <td><p>{dFormattedDate}</p></td>
        )
    }

    if (["PEOPLES"].includes(cFieldType)) {
        return (
            <>
                <RcmpCardUsers aUsers={cValueText} bSmall={true} />
            </>
        )
    }


  if (["PEOPLES"].includes(cFieldType)) {
    return (
      <>
        <RcmpCardUsers aUsers={cValueText} bSmall={true} />
      </>
    )
  }

  return (
    <>
      <p>{cOriginalValue}</p>
    </>

  )

})


export default React.memo(RcmpTableField)